module.exports = __webpack_public_path__ + "img/COLLIDING_SPHERES.fc834a62.png";